import React from 'react';
import Stack from '@mui/material/Stack';
import { Navigate } from 'react-router-dom';
import kobrosData from '../../constants/products/kobros';
import ProductHero from './components/ProductHero';
import ProductSection from './components/ProductSection';
import RecommendationSection from './components/RecommendationSection';
import { STACK_PRODUCT_SECTION_COMPONENT } from '../../constants/mui-components';
import useGetCountry from '../../helpers/useGetCountry';
import CountryEnum from '../../constants/country-enum';
import DemoForm from './kobros/DemoForm';

function KoBros() {
  const country = useGetCountry();
  if (country === CountryEnum.MEXICO) {
    return <Navigate to="/" replace />;
  }
  return (
    <>
      <ProductHero productData={kobrosData} />
      <Stack className={STACK_PRODUCT_SECTION_COMPONENT}>
        <ProductSection productData={kobrosData.description_information} />
        <ProductSection
          productData={kobrosData.benefits_information}
          flexDirection="row-reverse"
        />
        <ProductSection
          productData={kobrosData.requirements_information}
          stackProps={{
            style: {
              gap: '2rem',
            },
          }}
        />
      </Stack>
      <DemoForm demoData={kobrosData.demo} />
      <Stack className={STACK_PRODUCT_SECTION_COMPONENT}>
        <RecommendationSection actualProductName={kobrosData.name} />
      </Stack>
    </>
  );
}

export default KoBros;
